// extracted by mini-css-extract-plugin
export default {"anchor":"Anchor-module__anchor__t2+ZA","content":"Anchor-module__content__vrmgP"};